import { Alert } from "reactstrap";
import { useTranslation } from 'react-i18next';

export const WelcomeAlert = () => {
  const { t } = useTranslation();

  return (
    <Alert className="alert alert-additional color-primary mb-3 shadow-sm">
      <div className="alert-body">
        <div className="d-flex">
          <div className="flex-shrink-0 me-3">
            <div className="avatar-sm">
              <div className="avatar-title bg-light color-primary rounded-circle fs-16">
                <i className="ri-open-arm-line  fs-20 align-middle"></i>
              </div>
            </div>
          </div>
          <div className="flex-grow-1">
            <h5 className="alert-heading">
              {t('Welcome')}!
            </h5>
            <p className="mb-2">
              {t('Enter')} <strong> {t('name')} </strong> {t('or')} <strong> {t('nickname')} </strong>{t('and')} <strong>{t('join the event')}</strong>, {t('to')} <strong>{t('add songs')}</strong> {t('and')} <strong>{t('vote')}</strong>{t('.')}
            </p>
          </div>
        </div>
      </div>
    </Alert>
  );
};
